// On Keydown hook
// Params
// key: The key or keys that we want to listen for. Set to empty string, null or 'default'
// to listen to all keys
// The callback function that gets called when the key is hit
import { useEffect } from 'react';

const useOnKeydown = (key, cb, watch) => {
	useEffect(() => {
		const isKeyDefault = key === '' || key === null || key === 'default';
		const keys = Array.isArray(key) ? key : [key];

		const handler = (e) => {
			if(isKeyDefault || keys.includes(e.key)) cb(e);
		};

		document.addEventListener('keydown', handler);

		return () => {
			document.removeEventListener('keydown', handler);
		};
	}, watch);
};

export default useOnKeydown;
